import {sectionListDocsRu, sectionListDocsEn} from "../utils/sections";


export const locales = {'en': sectionListDocsEn, 'ru': sectionListDocsRu};

export function getCurrentLocale(pathname) {
    return pathname.split('/').find(p => Object.keys(locales).includes(p));
}
